import { Record } from 'immutable'

const PermissionRecord = Record({
  claims: [],
  customers: {},
})

export default PermissionRecord
